<template>
  <v-card>
    <v-card-title primary-title class="warning lighten-2">
      {{ label }}
    </v-card-title>
    <v-card-text class="pt-2">
      กรุณาแนะตัวท่านเองเพื่อให้ได้รู้จักท่านดีขึ้น
      (เช่นความสำเร็จที่ผ่านมาหรือลักษณะงานซึ่งท่านถนัดและสนใจมากที่สุด
      หรืออธิบายความรับผิดชอบในงานปัจจุบัน) (Please provide any further
      information about yourself which will anable to know you better)
      <v-textarea
        outlined
        placeholder="กรอกแนะนำตนเอง"
        name="tea_remark"
        label="แนะนำตนเอง"
        v-model="$store.state.dataFrm.tea_remark"
      ></v-textarea>
      ข้าพเจ้าขอรับรองว่าข้อความดังกล่าวเป็นความจริงทุกประการหากข้อความตอนหนึ่งตอนใดไม่ตรงกับความจริง
      ข้าพเจ้ายินดีให้วิทยาลัยเทคโนโลยีเลิกจ้างทันที
      โดยไม่ต้องจ่ายเงินค่าเสียหายใด ๆ ทั้งสิ้น. I hereby certify that all that
      statements in this application from are correct. I understand that false
      statement given in this application will be an adequate ground for
      disqualification.
    </v-card-text>
  </v-card>
</template>
<script>
// import datetimepicker_TH from "./datetimepickerTH";
export default {
  data() {
    return {};
  },
  components: {
    // datetimepicker_TH,
  },
  props: {
    label: {
      type: String,
      default: "",
    },
  },
  computed: {},
};
</script>
<style scoped>
.flex-center {
  display: flex;
  justify-content: center;
}
</style>
